<template>
  <div class="exam_details">
    <Details :crumbsConfig="crumbsConfig"/>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    crumbsConfig() {
      const moduleType = this.$route.query.moduleType
      // 18-客户案例
      const config = Object.is(+moduleType, 18)
        ? {
            url: '/example/list',
            text: '客户案例'
          }
        : {
            url: '/benchmarkExample',
            text: '标杆案例'
          }
      const data = [
        {
          url: '/',
          text: '首页'
        },
        config,
        {
          text: '案例详情'
        }
      ]
      return data
    }
  },
  created() {
  },
  methods: {}
};
</script>

<style scoped lang="scss">
@media (min-width: 751px) and (max-width: 960px) {
}
@media (min-width: 961px) {
}
</style>
